import React, { Component } from 'react';
import RDP_CONFIG from '../../config';
import { UserService } from '../../services/user';
import './element-head-1-properties.css';
import {
  RDPDamWidget, ColorPicker, FontPicker
} from '../../components';
import IconPerson  from "./person.svg";
import Checkbox from "../../components/element-checkbox/checkbox";
import PreferenceRequiredInteraction
  from "../../components/preference-required-interaction/preference-required-interaction";

export default class ElementHead1Properties extends Component {
  constructor(props) {
    super(props);

    this.state = {
      "content": this.props.content,
      "dam_widget_opened": false,
      "dam_active_asset": null,
      "avatar_backup": null,
      "rdp_dam_widget_type": "image"
    }

    this.onMediaChange = this.onMediaChange.bind(this);
    this.onContentTitleChange = this.onContentTitleChange.bind(this);
    this.onAvatarBorderColorChange = this.onAvatarBorderColorChange.bind(this);
    this.onPrimaryColorChange = this.onPrimaryColorChange.bind(this);
    this.onSecondaryColorChange = this.onSecondaryColorChange.bind(this);
    this.onMarginTopChange = this.onMarginTopChange.bind(this);
    this.onMarginBottomChange = this.onMarginBottomChange.bind(this);
    this.onCheckShowCategory = this.onCheckShowCategory.bind(this);
    this.onCheckShowAuthorName = this.onCheckShowAuthorName.bind(this);
    this.onCheckShowDivider = this.onCheckShowDivider.bind(this);
  }

  onContentTitleChange(e) {
    var content = this.state.content;
    content.content_title = e.currentTarget.value !== "" ? e.currentTarget.value : content.content_title;

    this.setState({
      "content": content
    }, function () {
      this.props.onContentChange(content)
    });
  }

  onAvatarBorderColorChange(color) {
    var content = this.state.content;
    content.avatar_border_color = color;
    this.setState({
      "content": content
    }, function () {
      this.props.onContentChange(content)
    });
  }

  onPrimaryColorChange(color) {
    var content = this.state.content;
    content.primary_color = color;
    this.setState({
      "content": content
    }, function () {
      this.props.onContentChange(content)
    });
  }

  onSecondaryColorChange(color) {
    var content = this.state.content;
    content.secondary_color = color;
    this.setState({
      "content": content
    }, function () {
      this.props.onContentChange(content)
    });
  }

  onMarginTopChange(e) {
    var content = this.state.content;
    var px = e.currentTarget.value !== "" ? e.currentTarget.value : content.margin_top;
    content.margin_top = px;
    this.setState({
      "content": content
    }, function () {
      this.props.onContentChange(content)
    });
  }

  onMarginBottomChange(e) {
    var content = this.state.content;
    var px = e.currentTarget.value !== "" ? e.currentTarget.value : content.margin_bottom;
    content.margin_bottom = px;
    this.setState({
      "content": content
    }, function () {
      this.props.onContentChange(content)
    });
  }

  onBackgroundImageChange() {
    this.setState({
      "dam_active_asset": "background_image",
      "dam_widget_opened": true
    })
  }

  onAvatarImageChange() {
    this.setState({
      "dam_active_asset": "avatar",
      "dam_widget_opened": true
    })
  }

  onAssetChange(asset) {
    const {
      content,
      dam_active_asset,
      rdp_dam_widget_type
    } = this.state;
    if (dam_active_asset === "background_image") {
      if (rdp_dam_widget_type === "image") content.background_image = asset;
      if (rdp_dam_widget_type === "video") content.background_video = asset;
    } else if (dam_active_asset === "avatar") {
      content.avatar = asset;
    }
    this.setState({
      "content": content,
      "dam_widget_opened": false,
      "dam_active_asset": null
    })
  }

  onRDPDamWidgetClose() {
    this.setState({
      "dam_widget_opened": false,
      "dam_active_asset": null
    })
  }

  onRemoveAvatar() {
    var content = this.state.content;
    var avatar_backup = content.avatar;
    content.avatar = null;
    this.setState({
      "content": content,
      "avatar_backup": avatar_backup
    })
  }

  onRestoreAvatar() {
    var content = this.state.content;
    content.avatar = this.state.avatar_backup;
    this.setState({
      "content": content,
    })
  }

  isDefaultAvatar() {
    var content = this.state.content;
    return (content.avatar === this.state.avatar_backup && this.state.avatar_backup !== null) || this.state.avatar_backup === null;
  }

  onCheckShowCategory(e) {
    var content = this.state.content;
    content.show_category = e.currentTarget.checked;
    this.setState({
      "content": content
    })
  }

  onCheckShowAuthorName(e) {
    var content = this.state.content;
    content.show_author_name = e.currentTarget.checked;
    this.setState({
      "content": content
    })
  }

  onCheckShowDivider(e) {
    var content = this.state.content;
    content.show_divider = e.currentTarget.checked;
    this.setState({
      "content": content
    })
  }

  renderDAMWidget() {
    if (this.state.dam_widget_opened === true) {
      return <RDPDamWidget
        labels={this.props.labels}
        type={this.state.rdp_dam_widget_type}
        onClose={() => this.onRDPDamWidgetClose()}
        onAssetChange={(asset) => this.onAssetChange(asset)}
      />;
    }
  }

  getBackgroundUrl(image) {
    var accessToken = UserService.getUser().access_token;
    if (image !== "https://pocs.digitalpages.com.br/rdpcomposer/media/head-1/background.png") {
      image += "&access_token=" + accessToken + "&project_key=" + RDP_CONFIG.projectKey;
    };
    return image;
  }

  getAvatarUrl(image) {
    if (image === null) return IconPerson;

    var accessToken = UserService.getUser().access_token;
    if (image !== "https://pocs.digitalpages.com.br/rdpcomposer/media/head-1/avatar.png") {
      image += "&access_token=" + accessToken + "&project_key=" + RDP_CONFIG.projectKey;
    };
    return image;
  }

  onFontChange(font) {
    var content = this.state.content;
    content.font_family = font;

    this.setState({
      "content": content
    }, function () {
      this.props.onContentChange(content)
    });
  }

  renderFont() {
    var content = this.state.content;
    var labels = this.props.labels;

    if (content.font_family) {
      return <FontPicker font={content.font_family} onFontChange={(font) => this.onFontChange(font)}/>
    } else {
      return <FontPicker hasFont={false} onFontChange={(font) => this.onFontChange(font)} noFontLabel={labels.elements.common_settings.label_no_has_font}/>
    }
  }

  onMediaChange(type) {
    this.setState({
      "rdp_dam_widget_type": type,
      "dam_active_asset": "background_image"
    }, function () {
      this.setState({
        "dam_widget_opened": true
      })
    })
  }

  onBackgroundRemove() {
    var content = this.state.content;
    content.background_image = null;
    content.background_video = null;
    this.setState({
      "content": content
    });
  }

  getAssetUrl(asset) {
    var accessToken = UserService.getUser().access_token;
    if (asset !== "https://pocs.digitalpages.com.br/rdpcomposer/media/head-1/background.png") {
      asset += "&access_token=" + accessToken + "&project_key=" + RDP_CONFIG.projectKey;
    };
    return asset;
  }

  renderItemMedia(content) {
    var content = this.state.content;
    var labels = this.props.labels;
    if (content.background_image !== null) {
      return <div className="element-accordion-properties-item-image-container">
        <img className="element-accordion-properties-item-image" src={this.getAssetUrl(content.background_image)} />
        <span className="element-accordion-properties-item-image-remove" onClick={() => this.onBackgroundRemove()}>{labels.elements.settings.element_accordion.content_label_btn_remove_asset}</span>
      </div>;
    } else if (content.background_video !== null) {
      return <div className="element-accordion-properties-item-video-container">
        <video className="element-accordion-properties-item-video" src={this.getAssetUrl(content.background_video)} />
        <span className="element-accordion-properties-item-video-remove" onClick={() => this.onBackgroundRemove()}>{labels.elements.settings.element_accordion.content_label_btn_remove_asset}</span>
      </div>;
    } else {
      return <div className="element-accordion-properties-item-upload-media">
        <button className="element-accordion-properties-item-upload-image" onClick={() => this.onMediaChange("image")}>{labels.elements.settings.element_accordion.content_label_insert_image}</button>
        <button className="element-accordion-properties-item-upload-video" onClick={() => this.onMediaChange("video")}>{labels.elements.settings.element_accordion.content_label_insert_video}</button>
      </div>
    }
  }

  render() {
    var content = this.state.content;
    var labels = this.props.labels;

    return (<div className="rdp-element-head-1-properties">
      <ul className="rdp-composer-element-edit-tabs">
        <li className="rdp-composer-element-edit-tabs-item active">{labels.elements.common_settings.label_tab_settings}</li>
      </ul>
      <div className="rdp-composer-element-edit-body">
      <span className="rdp-composer-element-edit-label">{labels.elements.settings.element_head_1.settings_label_content_title}:</span>
        <input type="text" className="rdp-composer-element-edit-input" onChange={(e) => this.onContentTitleChange(e)} defaultValue={content.content_title}></input>
        
        <span className="rdp-composer-element-edit-label">{labels.elements.settings.element_head_1.settings_label_background_image}:</span>
        {this.renderItemMedia()}

        {/* <span className="rdp-composer-element-edit-label">{labels.elements.settings.element_head_1.settings_label_background_image}:</span> */}
        {/* <img className="rdp-composer-element-head-1-background" onClick={() => this.onBackgroundImageChange()} src={this.getBackgroundUrl(content.background_image)} /> */}

        <span className="rdp-composer-element-edit-label">{labels.elements.settings.element_head_1.settings_label_avatar_image}:</span>
        <div className={["rdp-composer-element-head-1-avatar", content.avatar === null ? "add-avatar" : ""].join(" ")} onClick={() => this.onAvatarImageChange()}>
          <img src={this.getAvatarUrl(content.avatar)} />
        </div>

        <div className="rdp-composer-element-head-1-avatar-options">
          <button className="rdp-composer-element-head-1-avatar-add" type="button" onClick={() => this.onAvatarImageChange()} hidden={content.avatar !== null}>{labels.elements.settings.element_head_1.settings_button_avatar_add}</button>
          <button className="rdp-composer-element-head-1-avatar-remove" type="button" onClick={() => this.onRemoveAvatar()} hidden={content.avatar === null}>{labels.elements.settings.element_head_1.settings_button_avatar_remove}</button>
          <button className="rdp-composer-element-head-1-avatar-restore-default" type="button" onClick={() => this.onRestoreAvatar()} disabled={this.isDefaultAvatar()}>{labels.elements.settings.element_head_1.settings_button_avatar_restore}</button>
        </div>

        <div className="rdp-composer-element-head-1-input-checkbox-container">
          <label
            className="rdp-composer-element-head-1-input-checkbox-label"
          >
            <input
              className="rdp-composer-element-head-1-input-checkbox"
              type="checkbox"
              value={content.show_category !== undefined ? content.show_category : "on"}
              onChange={this.onCheckShowCategory}
              checked={content.show_category !== undefined ? content.show_category : true}
            />
            <span className="rdp-composer-element-head-1-input-checkbox-checkmark"/>
            <span className="rdp-composer-element-head-1-input-checkbox-text">
              {labels.elements.settings.element_head_1.settings_label_show_category}
            </span>
          </label>

          <label
            className="rdp-composer-element-head-1-input-checkbox-label"
          >
            <input
              className="rdp-composer-element-head-1-input-checkbox"
              type="checkbox"
              value={content.show_author_name !== undefined ? content.show_author_name : "on"}
              onChange={this.onCheckShowAuthorName}
              checked={content.show_author_name !== undefined ? content.show_author_name : true}
            />
            <span className="rdp-composer-element-head-1-input-checkbox-checkmark"/>
            <span className="rdp-composer-element-head-1-input-checkbox-text">
              {labels.elements.settings.element_head_1.settings_label_show_author_name}
            </span>
          </label>

          <label
            className="rdp-composer-element-head-1-input-checkbox-label"
          >
            <input
              className="rdp-composer-element-head-1-input-checkbox"
              type="checkbox"
              value={content.show_divider !== undefined ? content.show_divider : "on"}
              onChange={this.onCheckShowDivider}
              checked={content.show_divider !== undefined ? content.show_divider : true}
            />
            <span className="rdp-composer-element-head-1-input-checkbox-checkmark"/>
            <span className="rdp-composer-element-head-1-input-checkbox-text">
              {labels.elements.settings.element_head_1.settings_label_show_divider}
            </span>
          </label>
        </div>

        <span className="rdp-composer-element-edit-label">{labels.elements.settings.element_head_1.settings_label_avatar_border_color}:</span>
        <ColorPicker labels={this.props.labels} color={content.avatar_border_color} onChange={this.onAvatarBorderColorChange} />

        <span className="rdp-composer-element-edit-label">{labels.elements.settings.element_head_1.settings_label_primary_color}:</span>
        <ColorPicker labels={this.props.labels} color={content.primary_color} onChange={this.onPrimaryColorChange} />

        <span className="rdp-composer-element-edit-label">{labels.elements.settings.element_head_1.settings_label_secondary_color}:</span>
        <ColorPicker labels={this.props.labels} color={content.secondary_color} onChange={this.onSecondaryColorChange} />

        <span className="rdp-composer-element-edit-label">{labels.elements.settings.element_head_1.settings_label_label_font}:</span>
        {this.renderFont()}

        <PreferenceRequiredInteraction
          title={labels.elements.settings.preference_required_interaction.title}
          label={labels.elements.settings.preference_required_interaction.label}
          labels={labels}
          content={content}
          onContentChange={c => {
            this.setState({ content: c });
            this.props.onContentChange(c);
          }}
        />
      </div>
      {this.renderDAMWidget()}
    </div>);
  }
}
